<app-report-table-header-column></app-report-table-header-column>
<app-report-table-header-column></app-report-table-header-column>
<app-report-table-header-column name="reports.name"
                                column="name"
                                [enableSort]="true"
                                (onSort)="onSortChange($event)"></app-report-table-header-column>
<app-report-table-header-column name="reports.type"
                                column="report_type"
                                [enableSort]="true"
                                (onSort)="onSortChange($event)"></app-report-table-header-column>
<app-report-table-header-column name="reports.parameters"
                                column="parameters"></app-report-table-header-column>
<app-report-table-header-column name="reports.managed_by"
                                column="created_by_firstname"
                                [enableSort]="true"
                                (onSort)="onSortChange($event)"></app-report-table-header-column>
<app-report-table-header-column></app-report-table-header-column>
